<template>
    <div class="single-answer">
        <div class="q-privew" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{currentQuestion.questionNo}}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div @copy.prevent @contextmenu="rightClickDisable($event)" @mouseup="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
            <div class="pyq-tag-section" v-if="showPyqButton" style="margin-top: 10px; white-space: nowrap;">
                <div
                    v-for="(tag, index) in pyqTags"
                    :key="index"
                    class="pyq-card"
                    style="display: inline-block; margin-right: 8px;"
                >
                    <div class="pyq-btn" style="background-color: #039be5; color: white; padding: 6px 16px; border-radius: 4px; border: 1px solid #039be5; min-width: 60px; text-align: center;">
                        {{ tag }}
                    </div>
                </div>
            </div>
        </div>

        <div class="question-part" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div
                v-for="(opt, opIndex) in currentQuestion.options"
                :key="opIndex"
                class="que-row"
                :class="{'selected-option' : isQPchecked(opt, currentQuestion.correctAnswer),'correct-radio-colour' : isQPcorrect(opt, currentQuestion.correctAnswer) }"
            >
                <div class="que-col-1">
                    <span class="opction-text">{{ opt.index }}</span>
                    <div class="private-radio" v-if="showAnswerField">
                        <input
                            type="radio"
                            @click="onRadioChange(opt)"
                            :checked="isChecked(opt)"
                            color="red"
                            :id="opt.id"
                            :disabled="currentQuestion.disabled"
                        />
                        <i
                            v-if="isChecked(opt)"
                            aria-hidden="true"
                            class=  "v-icon notranslate mdi mdi-radiobox-marked theme--light"
                            :class="currentQuestion.yourAnswer ? currentQuestion.correctAnswer === currentQuestion.yourAnswer ? 'green--text' : ' red--text' : currentQuestion.isPreview ?'green--text' : opt.correct_answer && 'blue--text'"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
                        ></i>
                    </div>
                </div>
                <div class="que-col-2">                    
                  <label :for="opt.id">  
                      <div @copy.prevent @contextmenu="rightClickDisable($event)"  :class="{'option-font': !optionFont(opt)}"  @mouseup="rightClickDisable($event)" v-html="opt.option_text"></div>
                  </label>
                </div>
            </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row v-if="!QIdView">
                        <v-col cols="5"
                            ><label class="ans-text-3may">Your Answer: </label>{{ currentQuestion.yourAnswer }}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span></v-col
                        >
                        <v-col cols="6"
                            ><label class="ans-text-3may">Correct Answer:</label>
                            {{ currentQuestion.correctAnswer }}</v-col
                        >
                        
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="
                            currentQuestion.solutionVideos &&
                            currentQuestion.solutionVideos.length
                        "
                        @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div>
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution && currentQuestion.isPreview && currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5  class="Solution">Solution:</h5>
                <div  @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
     <div v-else-if="(currentQuestion.solution && currentQuestion.isPreview )|| this.currentQuestion.isShowSolution">
                <h5 class="Solution"  >Solution:</h5>
                <div   @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import SmoothScroll from 'smoothscroll-polyfill';
import constants from "@/utils/constants.js";
export default {
    name: "SingleAnsQue",
    props: ["currentQuestion", "showAnswerField", "QIdView","showSolution","openMandatoryQuePopup", "practiceSessionView"],
    data() {
        return {};
    },
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
        ...mapState("userStore", ["user", "myInstitute"]),
        showPyqButton() {
            console.log(this.user,'currentQuestion??');
            return (
                this.myInstitute?.id === constants.ONLINE_INSTITUTE_ID &&
                this.user?.role_code === 'ST' &&
                this.currentQuestion?.question_tags &&
                this.pyqTags.length > 0
            );
        },
        pyqTags() {
            console.log(this.currentQuestion,'currentQuestion??');
            if (!this.currentQuestion?.question_tags) return [];
            const tags = this.currentQuestion.question_tags.split(',');
            return tags
                .filter(tag => tag.includes('PYQ_'))
                .map(tag => tag.replace('PYQ_', '').trim());
        }
    },
    mounted() {
        this.renderMath();
        SmoothScroll.polyfill();
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        onRadioChange(opt) {
            // if (this.currentQuestion.parent_id) {
            //     this.$parent.currentQuestion.isAnswered = true;
            // } else {
            //     this.currentQuestion.isAnswered = true;
            // }
            if(this.currentQuestion.isAnswerDisabled === true){
                if(this.practiceSessionView!==true){
                    this.openMandatoryQuePopup();
                }
            }else{
                this.currentQuestion.isAnswered = true;
                window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
                this.setDisableSecondaryAction(true);
                this.currentQuestion.options = this.currentQuestion.options.map(
                    (x) => {
                        if (opt.index === x.index) {
                            x.correct_answer = true;
                        } else {
                            x.correct_answer = false;
                        }
                        return x;
                    }
                );
            }
            
        },
        isQPchecked(opt,correct_answer) {
            if(this.currentQuestion.isPreview && !this.currentQuestion.isShowSolution ) {
               return this.isChecked(opt); 
            }
            else {
                return this.isCorrect(opt, correct_answer);
            }
        },
        isQPcorrect(opt,correct_answer){
             if(this.isChecked(opt)==false && this.isCorrect(opt, correct_answer)==true || this.isChecked(opt)==true && this.isCorrect(opt, correct_answer)==false) {
               return true; 
            }
            else{
                return false;
            }
        },
        rightClickDisable(e) {
            e.preventDefault();   
        },
    },
    watch: {
        "currentQuestion.id": function (val) {
            this.renderMath();
            this.renderMath();
        },
        // showSolution(val){
        //     if(val){
        //         console.log(val,'val??',this.currentQuestion,'question?');
        //     }

        // }
    },
};
</script>